/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

import {configureStore} from '@reduxjs/toolkit'
import headerSlice from '../features/common/headerSlice'
import modalSlice from '../features/common/modalSlice'
import rightDrawerSlice from '../features/common/rightDrawerSlice'
import leadsSlice from '../features/leads/leadSlice'
import {loginReducer} from "./service/api/reducer/loginReducer";
import {userAccessMenuReducer} from "./service/api/reducer/user-access-menu/userAccessMenuReducer";
import {userAccessMenuDataTableReducer} from "./service/api/reducer/user-access-menu/userAccessMenuDataTableReducer";
import {updateUserAccessMenuReducer} from "./service/api/reducer/user-access-menu/updateUserAccessMenuReducer";
import {masterCompanyReducer} from "./service/api/reducer/setting/master-company/masterCompanyReducer";
import {updateMasterCompanyReducer} from "./service/api/reducer/setting/master-company/updateMasterCompanyReducer";
import {usersReducer} from "./service/api/reducer/users/usersReducer";
import {priceRatesReducer} from "./service/api/reducer/setting/master-price-rate/priceRatesReducer";
import {priceRateReducer} from "./service/api/reducer/setting/master-price-rate/priceRateReducer";
import {updatePriceRateReducer} from "./service/api/reducer/setting/master-price-rate/updatePriceRateReducer";
import {managerPersonsReducer} from "./service/api/reducer/master/manager-person/transManagerPersonsReducer";
import {managerPersonReducer} from "./service/api/reducer/master/manager-person/transManagerPersonReducer";
import {updateManagerPersonReducer} from "./service/api/reducer/master/manager-person/updateTransManagerPersonReducer";
import {customersReducer} from "./service/api/reducer/master/customers/transCustomersReducer";
import {customerReducer} from "./service/api/reducer/master/customers/transCustomerReducer";
import {updateCustomerReducer} from "./service/api/reducer/master/customers/updateTransCustomerReducer";
import {transportersReducer} from "./service/api/reducer/master/transporters/transTransportersReducer";
import {transporterReducer} from "./service/api/reducer/master/transporters/transTransporterReducer";
import {updateTransporterReducer} from "./service/api/reducer/master/transporters/updateTransTransporterReducer";
import {paymentTypesReducer} from "./service/api/reducer/master/payments-type/transPaymentTypesReducer";
import {paymentTypeReducer} from "./service/api/reducer/master/payments-type/transPaymentTypeReducer";
import {updatePaymentTypeReducer} from "./service/api/reducer/master/payments-type/updateTransPaymentTypeReducer";
import {userReducer} from "./service/api/reducer/users/userReducer";
import {updateUserReducer} from "./service/api/reducer/users/updateUserReducer";
import {deleteUserReducer} from "./service/api/reducer/users/deleteUserReducer";
import {provinceReducer} from "./service/api/reducer/postal-code/provinceReducer";
import {cityReducer} from "./service/api/reducer/postal-code/cityReducer";
import {scopeReducer} from "./service/api/reducer/user-access-menu/scopeReducer";
import {masterMenuReducer} from "./service/api/reducer/user-access-menu/masterMenuReducer";
import {ordersReducer} from "./service/api/reducer/transaction/orders/ordersReducer";
import {orderReducer} from "./service/api/reducer/transaction/orders/orderReducer";
import {updateOrderReducer} from "./service/api/reducer/transaction/orders/updateOrderReducer";
import {orderDetailReducer} from "./service/api/reducer/transaction/orders/orderDetailReducer";
import {orderDetailsReducer} from "./service/api/reducer/transaction/orders/orderDetailsReducer";
import {customerOrderReducer} from "./service/api/reducer/transaction/orders/customerOrderReducer";
import {ordersPostedReducer} from "./service/api/reducer/transaction/orders/ordersPostedReducer";
import {calculatedOrderReducer} from "./service/api/reducer/transaction/orders/calculatedOrderReducer";
import {billingReducer} from "./service/api/reducer/transaction/billing/billingReducer";
import {billingsReducer} from "./service/api/reducer/transaction/billing/billingsReducer";
import {billingsPostedReducer} from "./service/api/reducer/transaction/billing/billingsPostedReducer";
import {billingsPaidedReducer} from "./service/api/reducer/transaction/billing/billingsPaidedReducer";
import {calculatedBillingReducer} from "./service/api/reducer/transaction/billing/calculatedBillingReducer";
import {billingDetailsReducer} from "./service/api/reducer/transaction/billing/billingDetailsReducer";
import {billingDetailReducer} from "./service/api/reducer/transaction/billing/billingDetailReducer";
import {updateBillingReducer} from "./service/api/reducer/transaction/billing/updateBillingReducer";
import {
    billingOrderNumberDetailsReducer
} from "./service/api/reducer/transaction/billing/billingOrderNumberDetailsReducer";
import {shipmentsReducer} from "./service/api/reducer/transaction/shipment/shipmentsReducer";
import {shipmentReducer} from "./service/api/reducer/transaction/shipment/shipmentReducer";
import {shipmentsProblemReducer} from "./service/api/reducer/transaction/shipment/shipmentProblemsReducer";
import {shipmentProblemReducer} from "./service/api/reducer/transaction/shipment/shipmentProblemReducer";
import {arrivalsProblemReducer} from "./service/api/reducer/transaction/shipment/arrivalProblemsReducer";
import {arrivalProblemReducer} from "./service/api/reducer/transaction/shipment/arrivalProblemReducer";
import {lostItemsReducer} from "./service/api/reducer/other/lostItemsReducer";
import {lostItemReducer} from "./service/api/reducer/other/lostItemReducer";
import {systemLogReducer} from "./service/api/reducer/other/systemlogReducer";
import {systemLogsReducer} from "./service/api/reducer/other/systemlogsReducer";
import {incentiveReducer} from "./service/api/reducer/other/incentiveReducer";
import {incentivesReducer} from "./service/api/reducer/other/incentivesReducer";
import {incentiveProcessReducer} from "./service/api/reducer/other/incentiveProcessReducer";
import {dashboardReducer} from './service/api/reducer/dashboard/dashboardReducer'
import {monthlyOrderDeliveryOrderReducer} from './service/api/reducer/dashboard/monthlyOrderDeliveryOrderReducer'
import {billPaymentReducer} from './service/api/reducer/dashboard/billPaymentReducer'
import {deliveryReducer} from './service/api/reducer/dashboard/deliveryReducer'
import {paymentReducer} from './service/api/reducer/dashboard/paymentReducer'
import {vehicleAvailableReducer} from "./service/api/reducer/transaction/shipment/vehicleAvailableReducer";
import {vehiclesAvailableReducer} from "./service/api/reducer/transaction/shipment/vehiclesAvailableReducer";
import {serviceRouteReducer} from "./service/api/reducer/transaction/shipment/serviceRouteReducer";
import {serviceRoutesReducer} from "./service/api/reducer/transaction/shipment/serviceRoutesReducer";
import {receivedManagersReducer} from "./service/api/reducer/transaction/billing/billingsReceivedManagerReducer";
import {MasterUnitItemReducer} from "./service/api/reducer/master/master-unit/MasterUnitItemReducer";
import {MasterWeightItemReducer} from "./service/api/reducer/master/master-unit/MasterWeightItemReducer";

const combinedReducer = {
    header: headerSlice,
    rightDrawer: rightDrawerSlice,
    modal: modalSlice,
    lead: leadsSlice,
    loginState: loginReducer,
    userAccessMenuState: userAccessMenuReducer,
    userAccessMenuDataState: userAccessMenuDataTableReducer,
    updateUserMenuAccessState: updateUserAccessMenuReducer,
    masterCompanyState: masterCompanyReducer,
    updateMasterCompanyState: updateMasterCompanyReducer,
    usersState: usersReducer,
    userState: userReducer,
    updateUserState: updateUserReducer,
    deleteUserState: deleteUserReducer,
    managerPersonState: managerPersonReducer,
    managerPersonsState: managerPersonsReducer,
    updateManagerPersonState: updateManagerPersonReducer,
    transporterState: transporterReducer,
    transportersState: transportersReducer,
    updateTransporterState: updateTransporterReducer,
    customerState: customerReducer,
    customersState: customersReducer,
    updateCustomerState: updateCustomerReducer,
    paymentTypeState: paymentTypeReducer,
    paymentTypesState: paymentTypesReducer,
    updatePaymentTypeState: updatePaymentTypeReducer,
    priceRatesState: priceRatesReducer,
    priceRateState: priceRateReducer,
    updatePriceRateState: updatePriceRateReducer,
    provinceState: provinceReducer,
    postalCodeState: cityReducer,
    scopeState: scopeReducer,
    masterMenuState: masterMenuReducer,
    orderState: orderReducer,
    ordersState: ordersReducer,
    orderDetailState: orderDetailReducer,
    orderDetailsState: orderDetailsReducer,
    updateOrderState: updateOrderReducer,
    customerOrderState: customerOrderReducer,
    ordersPostedState: ordersPostedReducer,
    calculatedOrderState: calculatedOrderReducer,
    billingState: billingReducer,
    billingsState: billingsReducer,
    billingsPostedState: billingsPostedReducer,
    billingsPaidState: billingsPaidedReducer,
    receivedManagersState: receivedManagersReducer,
    billingDetailState: billingDetailReducer,
    billingDetailsState: billingDetailsReducer,
    updateBillingState: updateBillingReducer,
    calculatedBillingState: calculatedBillingReducer,
    billingOrderNumberDetailsState: billingOrderNumberDetailsReducer,
    shipmentsState: shipmentsReducer,
    shipmentState: shipmentReducer,
    shipmentsProblemState: shipmentsProblemReducer,
    shipmentProblemState: shipmentProblemReducer,
    vehicleAvailableState: vehicleAvailableReducer,
    vehiclesAvailableState: vehiclesAvailableReducer,
    serviceRouteState: serviceRouteReducer,
    serviceRoutesState: serviceRoutesReducer,
    arrivalsProblemState: arrivalsProblemReducer,
    arrivalProblemState: arrivalProblemReducer,
    lostItemsState: lostItemsReducer,
    lostItemState: lostItemReducer,
    systemLogsState: systemLogsReducer,
    systemLogState: systemLogReducer,
    incentiveState: incentiveReducer,
    incentivesState: incentivesReducer,
    incentiveProcessState: incentiveProcessReducer,
    dashboardState: dashboardReducer,
    monthlyOrderDeliveryOrderState: monthlyOrderDeliveryOrderReducer,
    billPaymentState: billPaymentReducer,
    deliveryState: deliveryReducer,
    paymentState: paymentReducer,
    masterUnitItemState: MasterUnitItemReducer,
    masterWeightItemState: MasterWeightItemReducer
}

export default configureStore({
    reducer: combinedReducer
})
